import {ChipsFilterList} from 'plugins/modules/filter/components/ChipsFilterList';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {getFilterTitleForGtag, isFilterWithCount} from 'plugins/modules/filter/helpers';
import {IFilterFacet, IFilterFacetVariant} from 'plugins/modules/filter/types';
import React, {FC, useCallback, useContext, useMemo} from 'react';
import {isBrowserContext} from 'core/helpers';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';
import {EventAction} from 'modules/google-analytics/constants';
import {FilterContext} from 'plugins/modules/filter/context/new';
import {useFiltersRouterPush} from '../../hooks/useFiltersRouterPush';

interface IProps {
    filter: IFilterFacet;
}

export const ChipsFilterController: FC<IProps> = ({filter}) => {
    const {pushRoute} = useFiltersRouterPush();
    const {filterList} = useContext(FilterContext);

    const sendFiltersGtag = useFiltersGtag();

    const filterInstance = useMemo(() => {
        if (!isBrowserContext()) {
            return null;
        }

        return BrowserFilters.getInstance();
    }, []);

    const handleApply = useCallback(
        (variant: IFilterFacetVariant) => {
            if (!filterInstance) {
                return;
            }

            const {code: variantCode} = variant;

            sendFiltersGtag(getFilterTitleForGtag(filterList, filter, variant));

            const {pathName} = filterInstance.userAddOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [filter, filterInstance, filterList, pushRoute, sendFiltersGtag],
    );

    const handleDiscard = useCallback(
        (variant: IFilterFacetVariant) => {
            if (!filterInstance) {
                return;
            }

            const {code: variantCode} = variant;

            sendFiltersGtag(getFilterTitleForGtag(filterList, filter, variant), EventAction.RemoveFilter);

            const {pathName} = filterInstance.userRemoveOneFilterValue(filter, variantCode);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [filter, filterInstance, filterList, pushRoute, sendFiltersGtag],
    );

    const withCount = isFilterWithCount(filter);

    return (
        <ChipsFilterList
            onApply={handleApply}
            onDiscard={handleDiscard}
            variants={filter.variants ?? []}
            withCount={withCount}
        />
    );
};
